<template>
  <div class="clientes">
    <div class="d-flex justify-content-between">
      <div class="input-group mb-3">
        <button v-on:click="handleAdicionar()" class="btn btn-success">
          <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
        </button>
      </div>

      <div class="input-group mb-3">
        <input
            v-on:keyup.enter="handlePesquisa()"
            type="text"
            class="form-control"
            placeholder="Pesquisar"
            aria-label="Pesquisar"
            aria-describedby="button-addon2">
        <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
          <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
        </button>
      </div>
    </div>
    <div class="d-flex">
      <table class="table table-sm-pc table-striped table-hover">
        <thead>
          <tr>
            <th width="25">#</th>
            <th>Identificação</th>
            <th width="175">Velocidade</th>
            <th width="85">Valor</th>
            <th width="75"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="plano in listaPlanos" :key="plano.id">
              <td scope="row">{{plano.id}}</td>
              <td>{{plano.descricao}}</td>
              <td>{{plano.download_kbps}}kbps / {{plano.upload_kbps}}kbps</td>
              <td>R$ {{moedaToStringBRL(plano.valor)}}</td>
              <td class="text-end">
                <button type="button" v-on:click="handleEditaPlanoISP(plano)" class="btn btn-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                </button>
                <button type="button" v-on:click="handleRemovePlanoISP(plano)" class="btn btn-danger btn-sm">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </td>

            </tr>
          </tbody>
      </table>
    </div>
    <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

    <!-- modal-edita-plano-isp -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-plano-isp" id="btn-modal-edita-plano-isp-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-plano-isp" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalPlanoISP.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Cadastrar novo Plano de Acesso
            </h5>
            <h5 v-if="!!modalPlanoISP.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando Plano de Acesso
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-10">
                <label class="required">Identificação</label>
                <input type="text" v-model="modalPlanoISP.data.descricao" class="form-control" placeholder="Nome do plano">
              </div>
              <div class="col-12 col-sm-6 col-lg-2">
                <label>Valor</label>
                <div class="input-group mb-3">
                  <span class="input-group-text">R$</span>
                  <input type="text"
                      id="modal-plano-isp-valor"
                      v-model="modalPlanoISP.data.valor"
                      v-on:keyup="modalPlanoChangeValor"
                      v-on:enter="modalPlanoChangeValor"
                      v-on:focus="modalPlanoValorCursorEnd"
                      class="form-control text-end"
                      placeholder="0,00">
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Download no contrato</label>
                <div class="input-group mb-3">
                  <input type="text" v-model.number="modalPlanoISP.data.download_contrato_kbps" class="form-control" placeholder="">
                  <span class="input-group-text">kbps</span>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Upload no contrato</label>
                <div class="input-group mb-3">
                  <input type="text" v-model.number="modalPlanoISP.data.upload_contrato_kbps" class="form-control" placeholder="">
                  <span class="input-group-text">kbps</span>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Download real</label>
                <div class="input-group mb-3">
                  <input type="text" v-model.number="modalPlanoISP.data.download_kbps" class="form-control" placeholder="">
                  <span class="input-group-text">kbps</span>
                </div>
            </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <label class="required">Upload real</label>
                <div class="input-group mb-3">
                  <input type="text" v-model.number="modalPlanoISP.data.upload_kbps" class="form-control" placeholder="">
                  <span class="input-group-text">kbps</span>
                </div>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-plano-isp-fecha">Fechar</button>
            <button type="button"
                v-if="!modalPlanoISP.data.id"
                v-on:click="handleModalPlanoISPCadastrar()"
                v-bind:disabled="!podeSalvarPlanoISP()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalPlanoISP.data.id"
                v-on:click="handleModalPlanoISPSalvar()"
                v-bind:disabled="!podeSalvarPlanoISP()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-plano-isp -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import moeda from '@/modules/moeda'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'CatalogoPlanoISP',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaPlanos: [],
      modalPlanoISP: {
        data: {
          id: undefined,
          descricao: '',
          valor: '0,00',
          download_kbps: 0,
          upload_kbps: 0,
          download_contrato_kbps: 0,
          upload_contrato_kbps: 0,
        },
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/plano-isp?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaPlanos = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetmodalPlanoISP();
      this.abreModalCadastroPlanoISP();
    },

    async handleEditaPlanoISP(plano) {
      this.resetmodalPlanoISP();

      this.modalPlanoISP.data = clone(plano);
      this.modalPlanoISP.data.valor = moeda.toStringBRL(plano.valor);

      this.abreModalCadastroPlanoISP();
    },

    handleRemovePlanoISP(plano) {
      dialogo.confirmacao(`Confirma remover o Plano de Acesso <b>${plano.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/plano-isp/${plano.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroPlanoISP() {
      document.getElementById('btn-modal-edita-plano-isp-abre').click();
    },

    resetmodalPlanoISP() {
      this.modalPlanoISP.data.id = undefined;
      this.modalPlanoISP.data.descricao = '';
      this.modalPlanoISP.data.valor = '0,00';
      this.modalPlanoISP.data.download_kbps = 0;
      this.modalPlanoISP.data.upload_kbps = 0;
      this.modalPlanoISP.data.download_contrato_kbps = 0;
      this.modalPlanoISP.data.upload_contrato_kbps = 0;
    },

    podeSalvarPlanoISP() {
      const valor = moeda.fromString(this.modalPlanoISP.data.valor);

      switch (true) {
        case (this.modalPlanoISP.data.descricao.length < 3):
        case (valor < 0):
        case (this.modalPlanoISP.data.download_kbps <= 0):
        case (this.modalPlanoISP.data.upload_kbps <= 0):
        case (this.modalPlanoISP.data.download_contrato_kbps <= 0):
        case (this.modalPlanoISP.data.upload_contrato_kbps <= 0):
          return false;

        default:
          return true;
      }
    },

    handleModalPlanoISPCadastrar() {
      const sendData = {
        id: undefined,
        valor: moeda.fromString(this.modalPlanoISP.data.valor),
        descricao: this.modalPlanoISP.data.descricao,
        download_kbps: this.modalPlanoISP.data.download_kbps,
        upload_kbps: this.modalPlanoISP.data.upload_kbps,
        download_contrato_kbps: this.modalPlanoISP.data.download_contrato_kbps,
        upload_contrato_kbps: this.modalPlanoISP.data.upload_contrato_kbps,
      };

      loading(true);

      api.post('/plano-isp', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-plano-isp-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalPlanoISPSalvar() {
      const sendData = {
        id: this.modalPlanoISP.data.id,
        valor: moeda.fromString(this.modalPlanoISP.data.valor),
        descricao: this.modalPlanoISP.data.descricao,
        download_kbps: this.modalPlanoISP.data.download_kbps,
        upload_kbps: this.modalPlanoISP.data.upload_kbps,
        download_contrato_kbps: this.modalPlanoISP.data.download_contrato_kbps,
        upload_contrato_kbps: this.modalPlanoISP.data.upload_contrato_kbps,
      };

      loading(true);
      api.put(`/plano-isp/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-plano-isp-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    moedaToStringBRL(entrada) {
      return moeda.toStringBRL(entrada);
    },

    modalPlanoChangeValor() {
      const valor = moeda.fromString(this.modalPlanoISP.data.valor);

      this.modalPlanoISP.data.valor = moeda.toStringBRL(valor);
      console.log('plano changed');
    },

    modalPlanoValorCursorEnd() {
      const myInput = document.getElementById('modal-plano-isp-valor');
      const pos = this.modalPlanoISP.data.valor.length;

      myInput.setSelectionRange(pos, pos);

      setTimeout(function() {
        myInput.setSelectionRange(pos, pos);
      }, 100);

      setTimeout(function() {
        myInput.setSelectionRange(pos, pos);
      }, 300);

      setTimeout(function() {
        myInput.setSelectionRange(pos, pos);
      }, 500);

    }
  },

  created() {
    this.handlePesquisa();

    // document.getElementById('btn-modal-edita-plano-isp-fecha').click();
    /*
    setTimeout(() => {
      this.handleAdicionar();

      this.modalPlanoISP.data.descricao = 'Plano de Acesso Teste Front';
      this.modalPlanoISP.data.senha_radius = '123465';
      this.modalPlanoISP.data.pool_ipv4_acesso_id = 0;
      this.modalPlanoISP.data.pool_ipv4_bloqueio_id = 0;
    }, 500);
    /* */
  }
}
</script>
